import React, {useState} from 'react';
import {BeatLoader} from "react-spinners";

export const ImageContainer = (props) => {

    const {className, src, alt, spinnerColour, size} = props;

    // Track which src has finished loading rather than a bare loading flag.
    // React reuses this component instance when navigating between pages, so a
    // flag would stay false from the previous image and the old icon would show
    // in place of the spinner until the new one decoded. Deriving it from src
    // means a new src is loading again immediately, in the same render.
    const [loadedSrc, setLoadedSrc] = useState(null);
    const loading = loadedSrc !== src;

    const onLoaded = () => {
        setLoadedSrc(src)
    }

    return <React.Fragment>
        <div className={className} style={loading?{}:{display: "none"}}>
            <div className='spinner'>
                <BeatLoader
                    color={spinnerColour}
                    size={size}
                    loading={loading}
                />
            </div>
        </div>
        <div style={loading?{display: "none"}:{}}>
            <img className={className} src={src} alt={alt}
            onLoad={onLoaded}/>
        </div>
    </React.Fragment>
}